export const ERROR_MESSAGE = {
  VIDEO_STORAGE_OVERFLOW:
    "동영상 저장소가 가득 찼습니다. 동영상은 100개까지 저장이 가능하니, 시청하지 않는 동영상을 제거하신 후 이용해주시기 바랍니다.",
  SEARCH_INPUT_IS_EMPTY:
    "원하시는 영상의 검색어를 입력하신 후 검색 버튼을 클릭해주시기 바랍니다.",
};

export const DELAY_TIME = 300;
export const ITEMS_PER_REQUEST = 10;
export const ALLOCATE_FOR_RENDER_PX = 40;
export const STORAGE_MAX_COUNT = 100;

export const DEVELOP_MODE = true;
